import { render, staticRenderFns } from "./TwitterSignIn.vue?vue&type=template&id=5a03c74f&"
import script from "./TwitterSignIn.vue?vue&type=script&lang=js&"
export * from "./TwitterSignIn.vue?vue&type=script&lang=js&"
import style0 from "./TwitterSignIn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports